<div class="liquid-glass"><ng-content></ng-content></div>